import React, { Component } from "react";

class Footer extends Component {
  state = {};
  render() {
    return <div id="footer">{window.ENV.FooterLabel}</div>;
  }
}

export default Footer;
